import { FunctionComponent } from "react";
import { Route } from "react-router-dom";
import { useStoreContext } from "../../contexts/StoreProvider";
import NoAccess from "../../pages/NoAccess";

const AdminRoute = ({ component, ...rest }) => {
  const {
    state: { user },
  } = useStoreContext();
  const Component: FunctionComponent = component;
  return (
    <Route
      {...rest}
      render={() =>
        user && user.role.name === "Administrator" ? (
          <Component />
        ) : (
          <NoAccess />
        )
      }
    />
  );
};

export default AdminRoute;
